import {
    Card, Modal, Space, Descriptions,
} from 'antd';
import React, {FC} from 'react';

import {createStringDate} from 'components/table/utils/table.utils';
import {ReactComponent as CloseIcon} from 'shared/assets/close.svg';
import {DATE_WITH_TIME_DOTS_SECONDS_12} from 'shared/constants/date-format';

import './modal-change-history.less';

interface IModalChangeHistoryProps {
    visible?: boolean;
    changeHistoryData?: IChangeHistoryData;
    onClose?: () => void;
}
export interface IChangeHistoryData {
    createdBy?: string;
    createdDate?: string;
    updatedDate?: string;
    updatedBy?: string;
}
export const ModalChangeHistory : FC<IModalChangeHistoryProps> = ({
    visible,
    onClose,
    changeHistoryData,
}: IModalChangeHistoryProps) => (
    <Modal
        className="modal-change-history"
        onCancel={onClose}
        centered
        visible={visible}
        width={680}
        closeIcon={<CloseIcon className="modal-close-icon" />}
    >
        <Card title="История изменений">
            <Space
                size={16}
                direction="vertical"
            >
                <Descriptions column={1}>
                    <Descriptions.Item label="Кто создал">
                        {changeHistoryData?.createdBy || 'неизвестно'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Когда создал">
                        {createStringDate(changeHistoryData?.createdDate, DATE_WITH_TIME_DOTS_SECONDS_12) as string
                            || 'неизвестно'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Кто изменил">
                        {changeHistoryData?.updatedBy || 'неизвестно'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Когда изменил">
                        {createStringDate(changeHistoryData?.updatedDate, DATE_WITH_TIME_DOTS_SECONDS_12) as string
                            || 'неизвестно'}
                    </Descriptions.Item>
                </Descriptions>
            </Space>
        </Card>
    </Modal>
);
